import { useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import useInputs from '../../../../utils/hooks/useInputs'
import CenterService from '../../../../services/centers/center.service'
import swalAlert from '../../../../utils/helpers/swalAlert'
import { AppModalContent } from '../../../../component/layout/AppModal'
import { Grid, Group, Stack } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import AppButton from '../../../../component/common/AppButton'
import AppInput from '../../../../component/form/AppInput'
import AppFileButton from '../../../../component/common/AppFileButton'
import AppCheckbox from '../../../../component/form/AppCheckbox'

const CenterManualFileForm = ({ centerId, selectedItem, close }) => {
  const fileRef = useRef(null)
  const [fileData, setFileData] = useState()
  const [fileName, setFileName] = useState()
  const { formatMessage: msg } = useIntl()
  const { t } = useTranslation()
  const { inputs, onChangeInputs, updateInputs } = useInputs()

  const [file, setFile] = useState()

  useEffect(() => {
    if (selectedItem?._id) {
      updateInputs(selectedItem)
      retrieveFile()
    }
    // TODO: Como cargar en inputs?.files el archivo existente?
  }, [selectedItem])

  useEffect(() => {
    if (inputs?.files?.[0]) {
      setFileData(URL?.createObjectURL(inputs?.files?.[0]))
      setFileName(inputs?.files?.[0]?.name)
      if (!inputs?.description)
        updateInputs({ ...inputs, description: inputs?.files?.[0]?.name })
    }
  }, [inputs])

  const retrieveFile = async () => {
    if (selectedItem && selectedItem?._id && selectedItem?.mimeType) {
      const response = await CenterService.contracts.file.getById({
        id: centerId,
        rowId: selectedItem?._id,
      })
      if (response !== null && response !== 'null') {
        const blob = new Blob([response], { type: selectedItem.mimeType })
        if (blob && blob?.type !== '') {
          const url = URL.createObjectURL(blob)
          setFileData(url)
        } else {
          setFileData(null)
        }
      }
    }
  }

  const handleSave = async () => {
    const formData = new FormData()

    console.log('handleSave', file)
    formData.append('description', file?.name || '-')
    formData.append('file', inputs?.files?.[0])

    const response = !inputs?._id
      ? await CenterService.contracts.file.create({
          id: centerId,
          body: formData,
        })
      : await CenterService.contracts.file.update({
          id: centerId,
          rowId: inputs?._id,
          body: {
            description: inputs?.description || '-',
          },
        })
    if (response) close()
  }

  const handleRemove = async () => {
    if (selectedItem?._id) {
      const response = await CenterService.contracts.file.remove({
        id: centerId,
        rowId: selectedItem?._id,
      })
      if (response) {
        close()
        swalAlert('success', msg({ id: 'fileDeleted' }))
      } else {
        swalAlert('error', msg({ id: 'fileDeleteError' }))
      }
    }
  }

  return (
    <AppModalContent
      buttons={[
        <AppButton
          preset="remove"
          invisible={!selectedItem?._id}
          onClick={handleRemove}
        />,
        <AppFileButton
          name="files"
          ref={fileRef}
          accept="application/pdf,image/*"
          onChange={onChangeInputs}
        />,
        <AppButton
          preset="save"
          disabled={!inputs?.files?.[0]}
          onClick={handleSave}
        />,
      ]}
      content={
        <Stack w="100%" h="100%">
          <Grid>
            <Grid.Col span={9}>
              <AppInput
                label="name"
                withAsterisk
                name="name"
                value={inputs?.name}
                onChange={onChangeInputs}
              />
            </Grid.Col>
            <Grid.Col span={3}>
              <AppCheckbox
                size="lg"
                label="installation"
                name="installation"
                checked={inputs?.installation}
                onChange={onChangeInputs}
              />
            </Grid.Col>
          </Grid>
          <Group>
            <AppInput
              placeholder="description"
              withAsterisk
              name="description"
              value={inputs?.description}
              onChange={onChangeInputs}
            />
          </Group>
          {!fileData && (
            <Group
              w="100%"
              mih={480}
              justify="center"
              className="iframe-empty"
              onClick={() =>
                document.querySelector("input[type='file']").click()
              }
            >
              {t('uploadFile')}
            </Group>
          )}
          {fileData && (
            <Group w="100%" mih={480} h={480}>
              <iframe
                src={fileData}
                title="Preview"
                style={{ width: '100%', minHeight: '480px' }}
              />
            </Group>
          )}
          <Group w="100%" justify="flex-end" fz="80%">
            {inputs?.files?.[0]?.name}
          </Group>
        </Stack>
      }
    />
  )
}

export default CenterManualFileForm
